/**
 * 商城首页活动区等前端展示辅助
 */

/** 活动图过滤（需有展示图） */
export function filterActivityItems(activities) {
  return (activities || []).filter(
    (item) => item && item.showImgId && item.showImgId.showImg
  );
}

/** C 区：第 1 行最多 2 个，第 2 行从第 3 个起 */
export function splitActivities(activities) {
  const list = filterActivityItems(activities);
  if (!list.length) {
    return { top: [], bottom: [] };
  }
  if (list.length === 1) {
    return { top: [list[0]], bottom: [] };
  }
  return {
    top: list.slice(0, 2),
    bottom: list.slice(2),
  };
}
